import type { RouteRecordRaw } from 'vue-router';

/**
 * Admin/system screens (Modules & Entitlements, Audit Log, Number Series, Localization). These are
 * core-platform screens, not business-module screens, so they are gated by permission (checked
 * inside each page, which renders `ForbiddenState` when missing) rather than `meta.requiresModule` —
 * unlike Catalog, there is no module to be "not entitled" to here (see AGENTS.md: module enable/
 * disable is an operator/CLI action, ADR-024, so there is nothing for a route guard to redirect on).
 * Spread this array into `router.ts`'s `routes` (inside the `AppShell` layout's `children`).
 */
export const adminSystemRoutes: RouteRecordRaw[] = [
  {
    path: 'admin/system/modules',
    name: 'admin-modules',
    component: () => import('../pages/admin/system/ModulesEntitlementsPage.vue'),
  },
  {
    path: 'admin/system/audit-log',
    name: 'admin-audit-log',
    component: () => import('../pages/admin/system/AuditLogPage.vue'),
  },
  {
    path: 'admin/system/number-series',
    name: 'admin-number-series',
    component: () => import('../pages/admin/system/NumberSeriesPage.vue'),
  },
  {
    path: 'admin/system/localization',
    name: 'admin-localization',
    component: () => import('../pages/admin/system/LocalizationPage.vue'),
  },
];
